import { Box } from '@truepill/react-capsule'
import SpeciesLogo from 'components/SpeciesLogo'
import { primaryBackgroundColor } from 'styles/styleVariables'

export const PV1PatientCardTitle = ({ isHumanPatient = false }: { isHumanPatient?: boolean }) => {
  return (
    <Box css={{ display: 'flex' }}>
      PATIENT
      <SpeciesLogo
        isHuman={isHumanPatient}
        css={{
          marginLeft: '0.5rem',
          backgroundColor: primaryBackgroundColor,
          '&>p': { paddingLeft: '0.125rem', paddingRight: '0.125rem' },
          '& svg': { width: '20px', height: '20px' },
        }}
      />
    </Box>
  )
}
